module.exports = __webpack_public_path__ + "media/42.f9f3fccf.mp3";